import areaProductDialogReducer from './areaProductDialogReducer';

export default areaProductDialogReducer;